let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([require("./helpers/browser/css-loader")(require('./helpers/bundle-manifest').resolve("1cveg")), load("l5P22")]).then(() => parcelRequire('egoXV'));